import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../core/helpers/isMobile';

import GameLogo from '../../../components/common/gameLogo';

const GameLogoWrapper = observer(() => {
  const { containerConfig } = useMemo(() => {
    return {
      containerConfig: {
        x: isMobile() ? 270 : 722,
        y: isMobile() ? 200 : 50,
      },
    };
  }, []);

  return <GameLogo containerConfig={containerConfig} />;
});

export default GameLogoWrapper;
